import { SearchFilterBuilder } from "../../../../../utilities/SearchFilterBuilder";
import { IGraphSearchUrlBuilder } from "../../../interfaces/IGraphSearchUrlBuilder";
import { IPageSettings } from "../../../interfaces/IPageSettings";
import { SearchValue } from "../../../redux/models/reduxModels";
import { BaseUrlSearchBuilder } from "./baseUrlSearchBuilder";

export class TeamSearchUrlBuilder extends BaseUrlSearchBuilder implements IGraphSearchUrlBuilder {
    constructor(private teamWebUrl: string[]) {
        super();
    }

    buildFolderQuery = (currentDirectory: IPageSettings, searchValue: SearchValue) => {
        return this.builSearchUrl(searchValue, false);
    }

    buildFileQuery = (currentDirectory: IPageSettings, searchValue: SearchValue) => {
        return this.builSearchUrl(searchValue, true);
    }

    private builSearchUrl = (searchValue: SearchValue, isFile: boolean) => {
        return `(*${searchValue.value}*) SiteTemplate:GROUP ${this.setFileType(isFile)} ${searchValue?.filterType !== "" ? SearchFilterBuilder(searchValue.filterType) : ""}`;
    }
}
